import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src2181442193/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
